import { render, staticRenderFns } from "./ongoingList.vue?vue&type=template&id=3169a019&scoped=true&lang=html"
import script from "./ongoingList.vue?vue&type=script&lang=js"
export * from "./ongoingList.vue?vue&type=script&lang=js"
import style0 from "./ongoingList.vue?vue&type=style&index=0&id=3169a019&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3169a019",
  null
  
)

export default component.exports